import { computed, ref, type ComputedRef, type Ref } from 'vue'
import { useSamudkoyStore } from '../../stores/samudkoy'

interface UsePopupTranslate {
  currentPage: Ref<number>
  show: ComputedRef<boolean>
  updateCurrentPage: Function
}

//------------------------------------------------
export function usePopupTranslate(): UsePopupTranslate {
  const samudkoyStore = useSamudkoyStore()

  const currentPage = ref(samudkoyStore.page)

  const show = computed(() => samudkoyStore.translate)

  function updateCurrentPage() {
    currentPage.value = samudkoyStore.page
  }

  return {
    currentPage,
    show,
    updateCurrentPage,
  }
}

//------------------------------------------------
export function usePopupTranslateMock(): UsePopupTranslate {
  const currentPage = ref(5)

  const show = computed(() => true)

  function updateCurrentPage() {
    console.debug('updateCurrentPage()')
  }

  return {
    currentPage,
    show,
    updateCurrentPage,
  }
}
